var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.955 8.955 0 20 0C31.045 0 40 8.955 40 20C40 31.045 31.045 40 20 40C8.955 40 0 31.045 0 20ZM27.845 25.4883L22.3567 20C22.3567 20 27.59 14.7683 27.845 14.5117C28.4967 13.8617 28.4967 12.8067 27.845 12.155C27.195 11.5033 26.14 11.5033 25.4883 12.155L20 17.6433C20 17.6433 14.7683 12.41 14.5117 12.155C13.8617 11.5033 12.8067 11.5033 12.155 12.155C11.5033 12.805 11.5033 13.86 12.155 14.5117L17.6433 20C17.6433 20 12.41 25.2317 12.155 25.4883C11.5033 26.1383 11.5033 27.1933 12.155 27.845C12.805 28.4967 13.86 28.4967 14.5117 27.845L20 22.3567C20 22.3567 25.2317 27.59 25.4883 27.845C26.1383 28.4967 27.1933 28.4967 27.845 27.845C28.4967 27.195 28.4967 26.14 27.845 25.4883Z",
    fill: "#F3B738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.9340a7ade52f79fb43a6fb3adfe423dd.svg";
export { ForwardRef as ReactComponent };